import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="text-2xl font-heading text-white cursor-pointer">
                丫丫漫画
              </Link>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
                下拉式翻页在线阅读，免费畅享全集漫画。韩漫、日漫、国漫一应俱全，给你流畅舒适的阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">漫画分类</h4>
              <div className="flex flex-col gap-2">
                {categories.filter((c) => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-400">
                <span>邮箱：support@jxjdxwx.cn</span>
                <span>工作时间：周一至周五 9:00-18:00</span>
                <div className="flex gap-4 mt-2">
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-white"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-white"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                    <i className="ri-qq-line text-white"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 丫丫漫画 版权所有 | 本站所有漫画均来自网络，仅供学习交流使用
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors duration-200 cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors duration-200 cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors duration-200 cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}